var map = {
	"./ADA.svg": 76773,
	"./AKT.svg": 57933,
	"./ALGO.svg": 7806,
	"./APT.svg": 69036,
	"./ARB.svg": 77692,
	"./ATOM.svg": 81836,
	"./AVAX.svg": 26033,
	"./AXL.svg": 43660,
	"./BASE.svg": 93068,
	"./BCH.svg": 30670,
	"./BLAST.svg": 62391,
	"./BNB.svg": 6191,
	"./BSC.svg": 25973,
	"./BSV.svg": 62808,
	"./BTC.svg": 9980,
	"./CELO.svg": 99936,
	"./CKB.svg": 72861,
	"./CORE.svg": 3158,
	"./CSPR.svg": 44071,
	"./DAG.svg": 15861,
	"./DAI.svg": 30307,
	"./DAO.svg": 26301,
	"./DASH.svg": 65427,
	"./DESO.svg": 53272,
	"./DGB.svg": 17306,
	"./DOGE.svg": 32624,
	"./DOT.svg": 40300,
	"./EGLD.svg": 72083,
	"./ENJ.svg": 39460,
	"./EOS.svg": 30138,
	"./ETC.svg": 56907,
	"./ETH.svg": 7936,
	"./EVER.svg": 16179,
	"./FIL.svg": 89176,
	"./FLOW.svg": 96699,
	"./FLR.svg": 75398,
	"./FTM.svg": 16198,
	"./HBAR.svg": 9316,
	"./ICP.svg": 27425,
	"./ICX.svg": 53689,
	"./KAI.svg": 46508,
	"./KAS.svg": 42678,
	"./KAVA.svg": 12256,
	"./KDA.svg": 18135,
	"./KLAY.svg": 36964,
	"./KSA.svg": 30366,
	"./KSM.svg": 81514,
	"./LTC.svg": 84490,
	"./MATIC.svg": 36779,
	"./MINA.svg": 92522,
	"./NBL.svg": 51825,
	"./NEAR.svg": 61190,
	"./OP.svg": 9290,
	"./OSMO.svg": 7941,
	"./POL.svg": 93848,
	"./RON.svg": 37332,
	"./ROSE.svg": 18462,
	"./RUNE.svg": 80715,
	"./SEI.svg": 86848,
	"./SOL.svg": 68527,
	"./STX.svg": 23830,
	"./SUI.svg": 65616,
	"./TIA.svg": 63171,
	"./TON.svg": 65222,
	"./USDC.svg": 30760,
	"./USDT.svg": 25271,
	"./VARA.svg": 33419,
	"./VET.svg": 78092,
	"./XLM.svg": 264,
	"./XRP.svg": 955,
	"./XTZ.svg": 96319,
	"./ZEC.svg": 20759,
	"./ZEN.svg": 42210,
	"./ZKSYNC_MAINNET.svg": 47198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65745;